import React from "react";
import { StyledBaseButton } from "./Button.style";

const IconButton = ({ children, className, ...rest }) => {
  return (
    <StyledBaseButton
      {...rest}
      className={`btn-ghost btn-xs btn-circle ${className}`}
    >
      {children}
    </StyledBaseButton>
  );
};

export default IconButton;
